// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
//AUTHENTICATE_DASHBOARD_ACCCESS

import axios from "axios";
import { encryptHeader } from "../utils/encryptHeader";
const API_ENDPOINT = require("../config/server");
const { getSession } = require("../utils/sessionstore");


export async function dashboardAuthAPI(dashboard) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "AUTHENTICATE_DASHBOARD_ACCCESS",
      Method: "POST",
    },

    Parameters: {
      data: {},
    },
  };
  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV":iv,
      dashboard: `${dashboard}`,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
  };

  const response = await axios(axiosoptions);

  return response.data;
}
